/**
 * @description User type logged for performance metrics
 */
export enum UserTypePM {
	ANON = 'ANON',
	CF = 'CF',
	LC = 'LC',
	MVPD_AUTHZ = 'MVPD_AUTHZ'
}